var _rect, _rect2, _circle, _circle2, _path, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProductSpeaker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 160 120",
    fill: "none",
    role: "img",
    "aria-label": "Bluetooth speaker",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 160,
    height: 120,
    rx: 10,
    fill: "#F3EEFA"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 34,
    width: 64,
    height: 52,
    rx: 14,
    fill: "#002454"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 60,
    r: 16,
    fill: "#9e00ff",
    opacity: 0.85
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 60,
    r: 8,
    fill: "#fff",
    opacity: 0.35
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58 88h44",
    stroke: "#002454",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 42,
    r: 3,
    fill: "#4ade80"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductSpeaker);
export default __webpack_public_path__ + "static/media/product-speaker.3501f8ca04de8879311e7c385eaeb7b3.svg";
export { ForwardRef as ReactComponent };